// extracted by mini-css-extract-plugin
export default {"photoPreview":"SiteProgressReportEditor_photoPreview__KJyHz","deletePhoto":"SiteProgressReportEditor_deletePhoto__GVkvd"};